import * as actionTypes from 'constants/ActionTypes';

export function getVesselClaims() {
    return {
        type: actionTypes.GET_VESSEL_CLAIMS.REQUEST,
    };
}

export function acceptUserClaimsToVessel(userId, vesselId) {
    return {
        type: actionTypes.ACCEPT_USER_CLAIMS_TO_VESSEL.REQUEST,
        userId,
        vesselId,
    };
}

export function rejectUserClaimsToVessel(userId, vesselId) {
    return {
        type: actionTypes.REJECT_USER_CLAIMS_TO_VESSEL.REQUEST,
        userId,
        vesselId,
    };
}



// WEBPACK FOOTER //
// ./app/actions/vessels/claims.js